export enum OcbAgentAuthenticationModes {
    OcbTokenLegacy = 0,
    AzureAd = 1,
    OcbToken = 2
}
